import React from "react";
import PropTypes from "prop-types";

export const FullScreenPopupBody = ({ containerID }) => {
  return <div id={containerID} className="full-screen-popup-container" />;
};

FullScreenPopupBody.propTypes = {
  containerID: PropTypes.string
};
